// @flow
import * as React from 'react'
import { Modal, Typography } from 'antd'
import { injectIntl } from 'react-intl'
import logo from './logo512.png'
import appleShare from './AppleShare.png'
import useIsIOS from './useisIOS'
import './index.css'

const { Title, Text, Paragraph } = Typography

const InstallPWA = ({ intl }: any) => {
  const { prompt } = useIsIOS()
  const [promptOpen, setPromptOpen] = React.useState(true)

  const title = intl.formatMessage({
    id: 'installpwa.title',
    defaultMessage: 'Install Ferrara Eventi',
  })

  const hidePrompt = () => setPromptOpen(false)

  return prompt ? (
    <Modal
      visible={promptOpen}
      footer={false}
      title={false}
      onCancel={hidePrompt}
      centered
      className="install-pwa-modal"
    >
      <figure className="app-logo">
        <img src={logo} alt={title} height="128" width="128" />
      </figure>
      <Title level={3}>{title}</Title>
      <Paragraph>
        {intl.formatMessage({
          id: 'installpwa.content',
          defaultMessage:
            'Install this application on yout homescreen for a better experience',
        })}
      </Paragraph>
      <div className="install-pwa-hint">
        <Text type="secondary">
          {intl.formatMessage({
            id: 'installpwa.hint.part1',
            defaultMessage: 'Tap',
          })}
        </Text>
        <img src={appleShare} alt="Share" width="20" height="20" />
        <Text type="secondary">
          {intl.formatMessage({
            id: 'installpwa.hint.part2',
            defaultMessage: 'then "Add to Home Screen"',
          })}
        </Text>
      </div>
    </Modal>
  ) : null
}

export default injectIntl(InstallPWA)
